import { ObservableArray, View } from "binder"
import { SendPackageLineItem, SendPackageRequestsViewModel, SendPackageSendable } from "./sendPackageRequests-viewModel"

export class SendPackageRequestsView extends View<SendPackageRequestsViewModel>{
    GetViewUniqueId(): string {
        return "V-B32477D3-A39E-4694-9CE1-01DC903B0A76"
    }
    loadHtml(): string {
        let element = require('./sendPackageRequests.html').default;
        let style = require('./sendPackageRequests.less');
        return element;
    }
    constructor() {
       super();
    }
    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName;} private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set sendPackageSendables(v: ObservableArray<SendPackageSendable>) { this._sendPackageSendables = v; } public get sendPackageSendables(): ObservableArray<SendPackageSendable> { return this._sendPackageSendables;} private _sendPackageSendables: ObservableArray<SendPackageSendable>;

}
